module.exports = __webpack_public_path__ + "media/images/emblems/Schwarzenburg-coat_of_arms-8bbd908caf6971073e9e9b0f836e888f.svg";